import { environment } from '@root/shared'

import * as Deeplink from './deeplink'

export const DeeplinkBuilder: {
  [T in Deeplink.Deeplink['_tag']]: (
    deeplink: Extract<Deeplink.Deeplink, { _tag: T }>,
  ) => string
} = {
  Trade: (payload) => {
    const params = new URLSearchParams()
    if (payload.maker) {
      params.set('maker', payload.maker)
    }
    const query = params.toString()
    const queryString = query ? `?${query}` : ''
    return `/trade/${payload.network}/${payload.pair}${queryString}`
  },
  InviteCodeJoin: (payload) => {
    const params = new URLSearchParams()
    params.set('code', payload.inviteCode)
    return `/invite?${params.toString()}`
  },
  UserProfile: (payload) => `/profile/${payload.delugeId}`,
  Homepage: () => '/homepage',
  Profile: () => '/profile',
  Nft: () => '/nft',
  TelegramAuth: ({ action, code, isExists }) => {
    const params = new URLSearchParams()
    params.set('action', action)
    params.set('code', code)
    params.set('isExists', isExists.toString())
    return `/tg-auth?${params.toString()}`
  },

  GoogleAuth: ({ state, code }) => {
    const params = new URLSearchParams()
    if (state) {
      params.set('state', state)
    }
    if (code) {
      params.set('code', code)
    }

    if (params.size === 0) {
      return '/google-auth'
    }

    return `/google-auth?${params.toString()}`
  },
  TwitterAuth: ({ authCode, state }) => {
    const params = new URLSearchParams()
    if (state) {
      params.set('state', state)
    }
    if (authCode) {
      params.set('authCode', authCode)
    }

    if (params.size === 0) {
      return '/twitter-auth'
    }

    return `/twitter-auth?${params.toString()}`
  },
  CheckCurrency: (_payload) => {
    const params = new URLSearchParams()
    params.set('queryAddress', _payload.queryAddress)
    params.set('network', _payload.network)
    return `/check-currency?${params.toString()}`
  },
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DeeplinkBuilder = typeof DeeplinkBuilder
export type KnownPages = keyof DeeplinkBuilder

const DEEPLINK_BASE_URL = environment.webUrl

export function getURLFor<T extends KnownPages>(
  page: T,
  payload: Parameters<DeeplinkBuilder[T]>,
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const pathname = DeeplinkBuilder[page](...(payload as [any]))
  return new URL(DEEPLINK_BASE_URL + '/goto' + pathname)
}

export function fromDeeplink(deeplink: Deeplink.Deeplink, base?: string) {
  return new URL(
    (base ?? DEEPLINK_BASE_URL) +
      '/goto' +
      Deeplink.match(deeplink, DeeplinkBuilder),
  )
}
